import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const FooterWrapper = styled('div')({
  padding: "22px 27px",
  minHeight: "57px",
  background: "linear-gradient(108.75deg, #1B253C 0.96%, #11192A 111.67%)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "auto"
});

export const FooterLeft = styled('div')({
  fontWeight: "600",
  color: "#D1000E",
  fontSize: "12px"
});

export const FooterRight = styled('div')({
  fontWeight: "600",
  color: "#ffffff",
  fontSize: "10px"
});

export const SearchResultLink = styled(Link)({
  textDecoration: "none",
  color: "black"
});
